export const routes = {
    app: '/',
    users: '/users',
    sendList: '/send-list',
    report: '/report',
    archive: '/archive',
    company: '/company',
} as const;

export const ROUTER_ID = '/:id';
